import React from "react";
import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileOutlined,
} from "@ant-design/icons";

export const MAX_FILE_SIZE_MB = 10;
export const ACCEPTED_FILE_TYPES =
  ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg";

const ACCEPTED_EXT_SET = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "txt",
  "png",
  "jpg",
  "jpeg",
]);

export const formatFileSize = (bytes: number): string => {
  if (!bytes || bytes <= 0) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const fileIconFor = (typeOrName: string): React.ReactNode => {
  const t = (typeOrName || "").toLowerCase();
  const ext = t.includes(".") ? t.slice(t.lastIndexOf(".") + 1) : t;
  switch (ext) {
    case "pdf":
      return <FilePdfOutlined style={{ color: "#dc2626" }} />;
    case "xlsx":
    case "xls":
    case "csv":
      return <FileExcelOutlined style={{ color: "#16a34a" }} />;
    case "docx":
    case "doc":
      return <FileWordOutlined style={{ color: "#2263b3" }} />;
    case "png":
    case "jpg":
    case "jpeg":
      return <FileImageOutlined style={{ color: "#7c3aed" }} />;
    default:
      return <FileOutlined style={{ color: "#6b7280" }} />;
  }
};

// Returns null when the file passes validation, otherwise a human-readable
// reason so the caller can toast it.
export const validateFile = (file: File): string | null => {
  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    return `${file.name} exceeds ${MAX_FILE_SIZE_MB} MB`;
  }
  const name = file.name.toLowerCase();
  const dotIdx = name.lastIndexOf(".");
  if (dotIdx > -1) {
    const ext = name.slice(dotIdx + 1);
    if (!ACCEPTED_EXT_SET.has(ext)) {
      return `${file.name} is not a supported file type`;
    }
  }
  return null;
};

let idCounter = 0;
export const nextAttachmentId = (): string => {
  idCounter += 1;
  return `att-${Date.now()}-${idCounter}`;
};
